export default function PHP_fread() {
  return (
    <div>
      <h1>PHP_fread</h1>
    </div>
  );
}
